import { type FC } from "react";
import { useFeatureFlags } from "@packsize/feature-flags";

import { useUsers } from "@/hooks/user";
import { useRoles } from "@/hooks/roles";

import { UsersTemplate } from "./users.template";
import { UsersLegacyTemplate } from "./users-legacy.template";

export const Users: FC = () => {
	const { data: roles } = useRoles();
	const { data: users, isLoading: isUsersLoading, isError: isUsersError, refetch: refetchUsers } = useUsers();
	const { isFeatureFlagEnabled } = useFeatureFlags();

	if (isFeatureFlagEnabled("vaporware-company-link") === false) {
		return (
			<UsersLegacyTemplate
				isError={isUsersError}
				isLoading={isUsersLoading}
				users={users ?? []}
				roles={roles ?? []}
				onRetry={refetchUsers}
			/>
		);
	}

	return (
		<UsersTemplate
			isError={isUsersError}
			isLoading={isUsersLoading}
			users={users ?? []}
			roles={roles ?? []}
			onRetry={refetchUsers}
		/>
	);
};

export default Users;
